module.exports = __webpack_public_path__ + "img/logo.fceece4d.png";